export default {
    mounted(el, binding) {
        const handleClickOutside = (event) => {
            if (!document.body.contains(el)) {
                return;
            }

            // Проверяем исключения (exclude)
            const exclude = binding.arg ? document.querySelector(binding.arg) : null;

            if (el.contains(event.target)) {
                return;
            }

            if (exclude && exclude.contains(event.target)) {
                return;
            }

            if (typeof binding.value === "function") {
                binding.value(event);
            } else {
                console.error("Binding value is not a function");
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        el._clickOutsideHandler = handleClickOutside;
    },
    beforeUnmount(el) {
        if (el._clickOutsideHandler) {
            document.removeEventListener("mousedown", el._clickOutsideHandler);
            delete el._clickOutsideHandler;
        }
    },
};